export default {
    install(app) {
        app.config.globalProperties.$helper = this
    },
    priceFormatter(price) {
        try {
            let formattedPrice =
                price
                    .toFixed(0)
                    .replace(new RegExp('\\d(?=(\\d{3})+$)', 'g'), '$&,');

            
                return formattedPrice ;
               
        } catch (e) {
            return 0 ;
        }
    },
    numberShortener(number) {
        if (number < 1000) {
            return number
        } else if (number >= 1e3 && number < 1e6) {
            return (number / 1e3).toFixed(2).replace(/(\.0+|0+)$/, '') + 'K'
        } else if (number >= 1e6 && number < 1e9) {
            return (number / 1e6).toFixed(2).replace(/(\.0+|0+)$/, '') + 'M'
        } else if (number >= 1e9 && number < 1e12) {
            return (number / 1e9).toFixed(2).replace(/(\.0+|0+)$/, '') + 'B'
        } else {
            return (number / 1e12).toFixed(2).replace(/(\.0+|0+)$/, '') + 'T'
        }
    }
}